import { CaptionText } from '@prisjakt/ui/text/variants';
import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const Footer = styled(CaptionText)`
  padding-top: ${layout.spacing.small};
  padding-bottom: ${layout.spacing.small};
`;
